/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { ON_MARK_AS_DELIVERY_BOX } from "../graphql/onMarkAsDelivered.mutation";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IMarkAsDeliveredMethods extends IPluginMethodMap {
  MarkAsDelivered(args: any): Promise<any>;
}

export class MarkAsDeliveredService implements IAgentPlugin {
  readonly methods: IMarkAsDeliveredMethods;

  constructor() {
    this.methods = {
      MarkAsDelivered: this.MarkAsDelivered.bind(this),
    };
  }

  async MarkAsDelivered(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      let array = [args?.costumeID];

      console.log("sugaarray", array);
      if (client) {
        const res = await client.mutate({
          mutation: ON_MARK_AS_DELIVERY_BOX,
          variables: {
            data: {
              costumeId: array,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
